function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M108.089 51.4147L65.8735 47.8988C62.5863 47.6251 59.2808 47.6556 55.9992 47.9901L25.5475 51.094C16.7015 51.9956 8.76042 45.6532 7.68403 36.8268C7.52562 35.5278 7.25331 34.2453 6.87027 32.994L4.46987 25.1527C2.1898 17.7045 5.37353 9.67038 12.1366 5.80576C17.7486 2.59889 24.7089 2.92647 29.9949 6.64627L33.4709 9.09231C42.5534 15.4837 54.4655 16.2015 64.2498 10.947L64.8227 10.6393C71.6027 6.99826 79.7029 6.76838 86.6784 10.0191L115.514 23.4572C120.691 25.8695 124 31.0629 124 36.7737C124 45.3686 116.654 52.128 108.089 51.4147Z",
  stroke: "currentColor",
  strokeWidth: 6
});

function SvgOffroad2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 55,
    viewBox: "0 0 127 55",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffroad2);
export default __webpack_public_path__ + "static/media/offroad2.8fb5222c.svg";
export { ForwardRef as ReactComponent };